"use client";
import InputDataContent from "@/components/inquiryDetails/inputDataContent";
import ResultContent from "@/components/resultContent";
import { FlexCol } from "@/components/ui";

const SAMPLE = {
  postalCode: "1234567890",
  province: "تهران",
  district: "تهران",
  city: "تهران",
  street: "خیابان ولیعصر",
  floor: "3",
  number: "45",
  address: "تهران، شهرستان تهران، خیابان ولیعصر، پلاک ۴۵، طبقه ۳",
};

const inputContent = [{ label: "کد پستی", value: SAMPLE.postalCode }];

const resultContent = [
  { label: "استان", value: SAMPLE.province },
  { label: "شهرستان", value: SAMPLE.district },
  { label: "شهر", value: SAMPLE.city },
  { label: "خیابان", value: SAMPLE.street },
  { label: "شماره", value: SAMPLE.number },
  { label: "طبقه", value: SAMPLE.floor },
  { label: "آدرس کامل", value: SAMPLE.address },
];

const PostalCodeSample = () => {
  return (
    <FlexCol className="items-stretch">
      <div className="mb-5 flex items-center justify-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-700">
        <span>⚠️</span>
        <span>این نتیجه صرفاً یک نمونه است و اطلاعات واقعی نیست</span>
      </div>

      <InputDataContent content={inputContent} />

      <ResultContent content={resultContent} />
    </FlexCol>
  );
};

export default PostalCodeSample;
